// src/pages/Mission/MissionPage.tsx
import HeroSection from "@/components/Marketing/HeroSection";
import IDSCRMProjectMap from "@/components/Marketing/IDSCRMProjectMap";
import IDSRoadmapTimeline from "@/components/Marketing/IDSRoadmapTimeline";


export default function MissionPage() {
    return (
        <div>
            {/* Hero header */}
            <HeroSection
                title="Our Mission"
                subtitle="Connecting every dealer, every customer, everywhere."
            />

            {/* Mission content */}
            <div className="container mx-auto px-6 py-20 space-y-10">
                <p className="text-center text-muted-foreground max-w-3xl mx-auto">
                    To transform the way dealerships operate — from the showroom to the service bay —
                    by giving them the tools, data, and technology to compete, connect, and grow
                    in the modern digital economy.
                </p>

                <div className="grid md:grid-cols-3 gap-10">
                    <div className="space-y-2">
                        <h3 className="font-semibold text-lg">Empower Dealers</h3>
                        <p className="text-sm text-muted-foreground">
                            Provide every dealer — from independents to groups — with enterprise-level tools
                            to compete with national platforms, without losing their identity.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h3 className="font-semibold text-lg">Unify Ecosystems</h3>
                        <p className="text-sm text-muted-foreground">
                            Break the silos between inventory, leads, finance, service, and marketing.
                            Create one operating system for all dealership operations.
                        </p>
                    </div>

                    <div className="space-y-2">
                        <h3 className="font-semibold text-lg">Elevate the Experience</h3>
                        <p className="text-sm text-muted-foreground">
                            Customers deserve transparency. Dealers deserve control.
                            IDSCRM bridges both worlds through smart, human-centered software.
                        </p>
                    </div>
                </div>

                <div className="text-center pt-10">
                    <p className="text-muted-foreground max-w-2xl mx-auto">
                        IDSCRM isn’t just software — it’s a movement to redefine what it means
                        to run, manage, and grow a dealership in the connected age.
                    </p>
                </div>
            </div>

            <IDSCRMProjectMap />

            {/* 🚀 New Roadmap Timeline */}
            <IDSRoadmapTimeline />
        </div>
    );
}
